import { ClubPlayer, type Night } from "@mixitone/models";
import { ApplicationView } from "@mixitone/mvc";
import SessionForm from "components/Forms/SessionForm";
import {
  consumePendingSessionTourFromClub,
  SESSION_TOUR_FROM_CLUB_STATE_KEY,
} from "components/Tour/tourStorage";
import AppModal from "components/common/AppModal";
import RouteController from "controllers/RouteController";
import { injectModal } from "lib/injectParams";
import { useCallback } from "react";

interface Props {
  clubId: string;
  recurringSessionId?: string;
  clubPlayerId?: string;
}

const NewSession: React.FC<Props> = ({ clubId, recurringSessionId, clubPlayerId }) => {
  const routeController = RouteController.use();

  const handleSubmit = useCallback(async (record: Night) => {
    if (clubPlayerId) {
      const clubPlayer = await ClubPlayer.query().findBy("id", clubPlayerId);
      if (clubPlayer) {
        await record.addClubPlayer(clubPlayer);
      }
    }

    const continueSessionTour = consumePendingSessionTourFromClub();
    routeController.actionCloseModal({
      at: "/t/:token",
      routeParams: { token: record.id! },
      ...(continueSessionTour && { state: { [SESSION_TOUR_FROM_CLUB_STATE_KEY]: true } }),
    });
  }, []);

  return (
    <AppModal title="New session">
      <SessionForm
        attributes={{ club_id: clubId, recurring_session_id: recurringSessionId }}
        onSubmit={handleSubmit}
      />
    </AppModal>
  );
};

export default injectModal(ApplicationView(NewSession));
